// extracted by mini-css-extract-plugin
module.exports = {"menu":"FilterMenu_menu__372aj","clearAll":"FilterMenu_clearAll__1BZEZ","group":"FilterMenu_group__cVGMC"};